import { render, staticRenderFns } from "./GroupScheduleExamForm.vue?vue&type=template&id=13bb1db6&"
import script from "./GroupScheduleExamForm.vue?vue&type=script&lang=js&"
export * from "./GroupScheduleExamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports